import * as React from 'react';
import {
  Wrapper,
  Legacy,
  Container,
  TermsAndConditions,
  AssesorsWrapper,
  SecurityWrapper,
  CentralHelp,
  CentralHelpSubtitle,
  BookImage
} from './styled';
import { Copyright } from '@app/src/common/footer';
import { isClientEnv } from '@app/src/utils/validations';
import { TERM_AND_CONDITIONS } from '@app/src/config/footer';
import * as BookClaimer from '@app/src/assets/img/book-claimer.jpg';

interface Props {
  isDisplay?: boolean;
  className?: string;
  showSecurity?: boolean;
}

const isClient = isClientEnv();
const BOOK_RECLAMATIONS = 'http://ecomedia.pe/libro/inicio/clasificados/';
const LINK_PREGUNTAS_FRECUENTES = '/preguntas-frecuentes';

export const Footer: React.FC<Props> = ({ isDisplay, className, showSecurity }) => {

  const handleClick = (e) => {
    let element = e.target;
    if (element.href) {
      pushDatalayer(element.href, element.textContent);
    }
  }

  const pushDatalayer = (href: string, text: string) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'Footer',
        'eventAction': href,
        'eventLabel': text,
        'eventValue': 1
      })
    }
  }

  return (
    <Wrapper isDisplay={isDisplay} className={className} onClick={e => handleClick(e)}>
      {showSecurity && <SecurityWrapper />}
      <Container>
        <AssesorsWrapper />
        <CentralHelp>
          <TermsAndConditions>
            <CentralHelpSubtitle>Legal</CentralHelpSubtitle>
            {
              TERM_AND_CONDITIONS &&
              TERM_AND_CONDITIONS.map((term, key) => (
                <li key={key}><a target="" href={term.link}>{term.text}</a></li>
              ))
            }
          </TermsAndConditions>
        </CentralHelp>
        <CentralHelp>
          <TermsAndConditions>
            <CentralHelpSubtitle>Ayuda</CentralHelpSubtitle>
            <li><a target="" href={LINK_PREGUNTAS_FRECUENTES}>Preguntas Frecuentes</a></li>
          </TermsAndConditions>
        </CentralHelp>
        <Legacy>
          <a target="_blank" href={BOOK_RECLAMATIONS}>
            <BookImage src={BookClaimer} alt="libro de reclamaciones" />
          </a>
          <p>Libro de reclamaciones</p>
          <Copyright />
        </Legacy>
      </Container>
    </Wrapper>
  )
};
